import { default as auth } from '../utils/auth';
import axios from 'axios';

export function submitOrder(order_data) {
    return axios.request({
        url: `/orders`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID(),
            'Customer-Id': auth.getUserId()
        },
        data: order_data
    });
}
